// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { resultCountProps } from "@store/Themes/common/props/resultCount";
import constants from "@store/constants";
import { ShipmentsDataViewContext } from "@store/Framework/Store/Greif/Data/Shipments/ShipmentsSelectors";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import React, { FC, useContext, useEffect, useState } from "react";

export interface TrailerTrackingResultCountStyles {
    trailerCountText?: TypographyPresentationProps;
}

export const resultCountStyles: TrailerTrackingResultCountStyles = {
    trailerCountText: resultCountProps.countText,
};

const styles = resultCountStyles;

const TrailerTrackingResultCount: FC<WidgetProps> = () => {
    const trailersDataView = usePersistentDataView(useContext(ShipmentsDataViewContext));

    let itemCount = 0;
    const [totalItem, setTotalItem] = useState((trailersDataView as any)?.properties?.totalCount);

    if (trailersDataView.value && trailersDataView.pagination) {
        itemCount = trailersDataView.pagination.totalItemCount;
    }

    useEffect(() => {
        if (trailersDataView.value && trailersDataView?.properties?.totalCount) {
            setTotalItem((trailersDataView as any)?.properties?.totalCount);
        }
    }, [trailersDataView]);

    if (!trailersDataView.value || !trailersDataView.pagination) {
        return null;
    }

    return (
        <Typography {...styles.trailerCountText} data-test-selector="trailerTracking_resultCount">
            {totalItem ? `${translate("{0} of {1}", String(itemCount), String(totalItem))} ` : `${String(itemCount)} `}
            {totalItem === 1 ? translate("Shipment") : translate(`${"Shipments"}`)}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: TrailerTrackingResultCount,
    definition: {
        group: constants.widgetGroup.trailerTracking,
        displayName: "Result Count",
        allowedContexts: [""],
    },
};

export default widgetModule;
